import { queryClient } from "@/ReactQuery/reactQueryClient";
import { BASE_API_URL, BASE_API_URL_V2 } from "../../../constants";
import fpFetch from "../../../services/fpFetch";
import { handleError } from "../../../utils/handleError";

const deleteUserUploadedFile = async (fileIds, folderPaths) => {
  try {
    openFpToast(`Deleting, please wait...`, "info", { duration: 10_000 });
    const body = { taskIds: fileIds };
    if (folderPaths && folderPaths.length > 0) {
      body.folderPaths = folderPaths;
    }
    const response = await fpFetch(`${BASE_API_URL_V2}/api/v2/tasks/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.status === 404) {
      throw new Error("Files not found");
    }
    if (!response.ok) {
      throw new Error(`Failed to delete files: ${response.status}`);
    }
    queryClient.invalidateQueries({ queryKey: ["orgFileList"] });
    openFpToast(`Deleted successfully.`, "success", { duration: 3_000 });
  } catch (error) {
    handleError(error);
    openFpToast(`Failed to delete`, "error");
  }
};

export default deleteUserUploadedFile;
